module.exports = __webpack_public_path__ + "media/images/icons/email-eab658360848b19acaf2643c03adf870.svg";